import { injectable } from '~/container'
import { BookingSubmitRequest, BookingSubmitResponse } from './schema'

@injectable()
export abstract class BookingSubmitService {
  abstract submit(_args: BookingSubmitRequest): Promise<BookingSubmitResponse>
}
